import { ElMessage } from "element-plus";

const messageTip = (key, tip, msg) => {
  let warning = "";
  if (tip && tip != "") {
    warning = `${tip}${msg}`;
  } else {
    warning = `${key}${msg}`;
  }
  return warning;
};

// 密码效验
const validatePassword = (value, tip) => {
  const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,15}$/;
  const msg = "由8-15位大小写字母、数字、特殊字符任意两种组成！";
  const warning = messageTip("密码", tip, msg);

  if (value == "" || value == undefined || value == null) {
    ElMessage.error(warning);
    return false;
  } else {
    if (value.length < 8 || value.length > 15) {
      ElMessage.error(warning);
      return false;
    }

    if (!reg.test(value) && value != "") {
        ElMessage.error(warning);
        return false;
    } else {
        return true;
    }
  }
};

// 邮箱地址效验
const validateEmail = (value, tip) => {
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  const msg = "格式不正确！";
  const warning = messageTip("邮箱地址", tip, msg);

  if (value == "" || value == undefined || value == null) {
    ElMessage.error(warning);
    return false;
  } else {
    if (!reg.test(value) && value != "") {
        ElMessage.error(warning);
        return false;
    } else {
        return true;
    }
  }
};

// 姓名效验
const validateUserName = (value, tip) => {
  const reg = /^([\u4e00-\u9fa5])*$/;
  const msg = "只允许输入中文！";
  const warning = messageTip("姓名", tip, msg);

  if (value == "" || value == undefined || value == null) {
    ElMessage.error(warning);
    return false;
  } else {
    if (!reg.test(value) && value != "") {
        ElMessage.error(warning);
        return false;
    } else {
        return true;
    }
  }
};

// 电话号码效验（固话和手机号）
const validatePhone = (value, tip) => {
  const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
  const msg = "号码格式不正确！";
  const warning = messageTip("电话", tip, msg);

  if (value == "" || value == undefined || value == null) {
    ElMessage.error(warning);
    return false;
  } else {
    if (!reg.test(value) && value != "") {
        ElMessage.error(warning);
        return false;
    } else {
        return true;
    }
  }
};

export default {
  validatePassword,
  validateEmail,
  validateUserName,
  validatePhone
};


